import Image from '@components/Image';
import useGetImagePublic from '@lib/useGetImagePublic';
import { DataDetailCheckout } from '../types';

interface BusinessNameProps {
  data?: DataDetailCheckout;
  title?: string;
  subtitle?: string;
  showLogo?: boolean;
  logoSize?: 'sm' | 'md' | 'lg';
}

const BusinessName: React.FC<BusinessNameProps> = ({
  data,
  title,
  subtitle,
  showLogo = true,
}) => {
  if (!data || !data.business) {
    return (
      <div className="flex h-20 items-center justify-center text-sm text-gray-500">
        Data tidak tersedia
      </div>
    );
  }

  const { business, merchant } = data;
  const { data: logoUrl } = useGetImagePublic(business?.logo_path);

  const displayTitle = title || merchant?.name || '-';
  const displaySubtitle = subtitle || business?.name || '-';

  return (
    <div className="w-full">
      <div className="flex items-start gap-6 md:items-center">
        {showLogo && logoUrl && (
          <div
            className={`h-16 w-16 shrink-0 overflow-hidden rounded-lg bg-gray-100`}
          >
            <Image
              className="h-full w-full object-cover"
              src={logoUrl}
              alt="Business Logo"
            />
          </div>
        )}
        <div className="flex flex-col gap-1">
          <h4 className="text-xl font-semibold">{business?.name || '-'}</h4>
          <h3 className="text-base font-bold text-gray-900">{displayTitle}</h3>
          {displaySubtitle && (
            <span className="text-sm font-medium text-gray-600">
              {displaySubtitle}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default BusinessName;
